import { render } from "./AuthenticatedLayout.vue?vue&type=template&id=c4c0f6a0&scoped=true"
import script from "./AuthenticatedLayout.vue?vue&type=script&lang=js"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=js"

import "./AuthenticatedLayout.vue?vue&type=style&index=0&id=c4c0f6a0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c0f6a0"]])

export default __exports__